import './Contact.css';
import { ReactComponent as Linkedin } from './svg/linkedin.svg';
import { ReactComponent as Telegram } from './svg/telegram.svg';

function Contact() {
  return (
    <footer
      id='contact'
      className='contact-container'
    >
      <p>Tatiana Ivanova</p>
      <p>
        <a
          target='_blank'
          rel='noreferrer'
          href='https://www.google.com/maps/place/%D0%93%D0%BE%D0%BC%D0%B5%D0%BB%D1%8C,+%D0%93%D0%BE%D0%BC%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%B0%D1%8F+%D0%BE%D0%B1%D0%BB%D0%B0%D1%81%D1%82%D1%8C,+%D0%91%D0%B5%D0%BB%D0%B0%D1%80%D1%83%D1%81%D1%8C/@52.4237915,30.3270687,10z/data=!3m1!4b1!4m6!3m5!1s0x46d4699b50faf1a5:0x5ecca30fd2361396!8m2!3d52.4313388!4d30.99367!16zL20vMDE1OWR6?entry=ttu'
        >
          Belarus, Gomel
        </a>
      </p>
      <p>
        <a href='tel:+375(29)383-19-13'>+375 (29) 383-19-13</a>

        <br />
        <a href='tel:+7(919)021-82-74'>+7 (919) 021-82-74</a>
      </p>
      <p>
        <a
          target='_blank'
          rel='noreferrer'
          href='https://mail.google.com/mail/u/0/#inbox'
        >
          tati.ivanova.87@gmail.com
        </a>
      </p>
      <p>
        <a href='https://www.linkedin.com/in/tatiana-ivanova-85370a239/'>
          <Linkedin className='social-link' />
        </a>
        <a href='https://t.me/tatianaivanova87'>
          <Telegram className='social-link' />
        </a>
      </p>
    </footer>
  );
}

export default Contact;
